import { CDK_ROW_TEMPLATE, CdkHeaderRow, CdkHeaderRowDef } from '@angular/cdk/table';
import { ChangeDetectionStrategy, Component, Directive, HostBinding, Input, ViewEncapsulation } from '@angular/core';

/**
 * Header row definition for the table.
 * Captures the header row's template and other header properties such as the columns to display.
 */
@Directive({
  selector: '[nHeaderRowDef]',
  providers: [{ provide: CdkHeaderRowDef, useExisting: NHeaderRowDefDirective }],
})
export class NHeaderRowDefDirective extends CdkHeaderRowDef {
  @Input('nHeaderRowDef') override columns: Iterable<string>;
  @Input('nHeaderRowDefSticky') override sticky: boolean;
}

/** Header template container that contains the cell outlet. Adds the right class and role. */
@Component({
  selector: 'n-header-row, tr[n-header-row]',
  template: CDK_ROW_TEMPLATE,
  // See note on CdkTable for explanation on why this uses the default change detection strategy.
  changeDetection: ChangeDetectionStrategy.Default,
  encapsulation: ViewEncapsulation.None,
  exportAs: 'nHeaderRow',
  providers: [{ provide: CdkHeaderRow, useExisting: NHeaderRowComponent }],
})
export class NHeaderRowComponent extends CdkHeaderRow {
  @HostBinding('attr.class') class = 'n-header-row';
  @HostBinding('attr.role') role = 'row';
}
